<template>
    <section class="c-o-section-ratings">
        <h2 class="c-o-section-ratings__title"> {{ headline }}</h2>
        <div class="c-o-section-ratings__content">
            <latest-rating-molecule class="c-o-section-ratings__rating" v-for="(item, key) in ratings" :key="key" :rating="item"></latest-rating-molecule>
        </div>
    </section>
</template>

<script>

    import LatestRatingMolecule from '../../molecules/MoleculeRating.vue';

    export default {
        props: {
            content: {
                type: Object,
                default: () => ({
                    headline: ''
                }),
            },
            data: {
                type: Object,
                default: () => ({
                  ratings: []
                }),
            },
        },
        components: {
            LatestRatingMolecule
        },
        data() {
            const { headline = '' } = this.content || {};
            const { ratings = [] } = this.data || {};
            return {
                headline: headline,
                ratings: ratings
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/page-sections/OrganismSectionRatings.vue